exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._33Chc{z-index:2;position:relative;font-weight:400}", ""]);

// exports
exports.locals = {
	"root": "_33Chc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SpareRubricsLinks/SpareRubricsLinks.css
// module id = 2890
// module chunks = 1